import {useAppDispatch} from '../../../redux/hooks';
import {setActiveContent} from '../../../redux/slices/content/contentSlice';
import {ActiveContent} from '../../../redux/slices/content/contentType';

export const SystemContent = () => {
    const dispatch = useAppDispatch();

    return (
        <div>
            <div className='row justify-content-evenly'>
                <div onClick={() => dispatch(setActiveContent(ActiveContent.Voelker))}
                     className='col-3 systemContent-card mt-3'>
                    Völker
                </div>
                <div onClick={() => dispatch(setActiveContent(ActiveContent.Subvoelker))}
                     className='col-3 systemContent-card mt-3'>
                    Subvölker
                </div>
            </div>
            <div className='row justify-content-evenly'>
                <div onClick={() => dispatch(setActiveContent(ActiveContent.Klassen))}
                     className='col-3 systemContent-card mt-3'>
                    Klassen
                </div>
                <div onClick={() => dispatch(setActiveContent(ActiveContent.Subklassen))}
                     className='col-3 systemContent-card mt-3'>
                    Subklassen
                </div>
            </div>
            <div className='row justify-content-evenly'>
                <div onClick={() => dispatch(setActiveContent(ActiveContent.Manatabellen))}
                     className='col-3 systemContent-card mt-3'>
                    Manatabellen
                </div>
            </div>
            <div className='row justify-content-evenly'>
                <div onClick={() => dispatch(setActiveContent(ActiveContent.Testpage))}
                     className='col-3 systemContent-card mt-3'>
                    Testpage
                </div>
            </div>
        </div>
    )
}